import { render, staticRenderFns } from "./UpdateGroup.vue?vue&type=template&id=b18655ba"
import script from "./UpdateGroup.vue?vue&type=script&lang=js"
export * from "./UpdateGroup.vue?vue&type=script&lang=js"
import style0 from "./UpdateGroup.vue?vue&type=style&index=0&id=b18655ba&prod&lang=scss"
import style1 from "./UpdateGroup.vue?vue&type=style&index=1&id=b18655ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports